import {
    CHANGE_ACIENT,
    SELECT_LANGUAGE,
    SET_CHAT_SENDER_LANG,
    SET_CHAT_SPEECH_DETECT,
    SET_CHAT_TRANSLATOR_STATUS,
    SET_CHAT_USER_SPEAKING,
    SET_LANGUAGE_GENDER,
    SET_START_SPEECH_TIMER
} from "./actionTypes";

export function setSelectLang(lang: string) {
    return {
        type: SELECT_LANGUAGE,
        lang
    };
}

export function setChangeAcient(langForm: string) {
    return {
        type: CHANGE_ACIENT,
        langForm
    };
}
export function setChatUserSpeak(chatUserSpeaking: Boolean) {
    return {
        type: SET_CHAT_USER_SPEAKING,
        chatUserSpeaking
    };
}
export function setChatFirstWordDetect(isChatFirstWordDetect: Boolean) {
    return {
        type: SET_CHAT_SPEECH_DETECT,
        isChatFirstWordDetect
    };
}
export function setChatSenderLanguage(chatSenderLanguage: String) {
    return {
        type: SET_CHAT_SENDER_LANG,
        chatSenderLanguage
    };
}
export function setChatTranslatorStatus(chatTranslatorStatus: Boolean) {
    console.log("chatTranslatorStatus ",chatTranslatorStatus)

    return {
        type: SET_CHAT_TRANSLATOR_STATUS,
        chatTranslatorStatus
    };
}
export function setChatLanguageGenders(chatLanguageGender: any) {
    return {
        type: SET_LANGUAGE_GENDER,
        chatLanguageGender
    };
}
export function setStartSpeechTimer(startSpeechTimer: any) {
    return {
        type: SET_START_SPEECH_TIMER,
        startSpeechTimer
    };
}

